// extracted by mini-css-extract-plugin
module.exports = {"batch-process-table__header":"BatchProcessTable_batch-process-table__header__1-08L","batch-process-table__header-cell":"BatchProcessTable_batch-process-table__header-cell__32grc"};